import React from 'react';
import { AddressContainer } from '../../../../../common/address/containers/address.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { BillingAddressContainer } from '../../../../../common/billing-address/containers/billing-address.container';
import { ShippingAddressContainer } from '../../../../../common/shipping-address/containers/shipping-address.container';

export const TransporterAddressComponent = ({ handleInnerFormChange, selectedTransporters }: any) => {

    return (<>
        <AddressContainer
            onInnerFormChange={handleInnerFormChange}
            selectedAddress={selectedTransporters?.Address}
        />

        <AccordionContainer
            child={
                <div>
                    <InputContainer
                        label="Use PrimaryAddress As BillingAddress"
                        name="IsUsePrimaryAddressAsBillingAddress"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'Address.IsUsePrimaryAddressAsBillingAddress',
                                selectedTransporters?.Address
                            )
                        }}
                        type="checkbox"
                        value={selectedTransporters?.Address?.IsUsePrimaryAddressAsBillingAddress}
                    />
                    {!selectedTransporters?.Address?.IsUsePrimaryAddressAsBillingAddress &&
                        <BillingAddressContainer
                            onInnerFormChange={handleInnerFormChange}
                            selectBillingAddress={selectedTransporters?.Address} />}

                </div>}
            expandedPanel="billingAddressInfo"
            headerTitle="Billing Address Info"
        />
        <AccordionContainer
            child={
                <div>
                    <InputContainer
                        label="Use PrimaryAddress As BillingAddress"
                        name="IsUsePrimaryAddressAsBillingAddress"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'Address.IsUsePrimaryAddressAsShippingAddress',
                                selectedTransporters?.Address
                            )
                        }}
                        type="checkbox"
                        value={selectedTransporters?.Address?.IsUsePrimaryAddressAsShippingAddress}
                    />
                    {!selectedTransporters?.Address?.IsUsePrimaryAddressAsShippingAddress &&
                        <ShippingAddressContainer
                            onInnerFormChange={handleInnerFormChange}
                            selectShippingAddress={selectedTransporters?.Address} />}
                </div>}
            expandedPanel="shippingAddressInfo"
            headerTitle="Shipping Address Info"
        />
    </>)
}
export default TransporterAddressComponent;
